import { Indicator } from './Indicator'

import { salary } from '../../i18n/translatedMessages'

import { useEffect } from 'react'

const color = {
	employee: {
		label: salary.collaboratorChoice,
		primary: 'tw-bg-[#0D554A] tw-text-white',
		secondary: 'tw-bg-[#00A28B] tw-text-white',
		lightColor: 'tw-bg-[#C7FFF1] tw-text-[#00A28B]',
	},
	algorithm: {
		label: salary.suggestionsText,
		primary: 'tw-bg-[#084E72] tw-text-white',
		secondary: 'tw-bg-[#008ACD] tw-text-white',
		lightColor: 'tw-bg-[#DFF3FE] tw-text-[#008ACD]',
	},
}

export function CarrerIndicators({ employee, view }) {
	useEffect(() => {
		//console.log(employee)
		console.log(view)
	}, [view])
	return (
		<div>
			<div className='tw-my-2'>
				<h4 className='tw-font-bold tw-text-xl'>{salary.carrerIndicatorsNextStep}</h4>
				<p>{salary.carrerIndicatorsSubtitle}</p>
			</div>

			<div className='tw-grid tw-grid-cols-1 tw-gap-4 tw-mt-8'>
				<div className='tw-flex tw-flex-col tw-w-full'>
					<div className='tw-flex tw-gap-2'>
						<span className='tw-font-bold'>{color[view].label}</span>
					</div>
					<div className='tw-w-full border tw-rounded-md tw-bg-[#F9FAFC] tw-p-2 tw-h-full tw-flex tw-flex-col tw-justify-between'>
						<div className='tw-p-2 tw-mt-2 tw-space-y-2 tw-h-[200px] tw-overflow-auto'>
							{employee[`next_steps_${view}`].map((item, index) => (
								<div key={index} className='tw-flex tw-items-center tw-justify-between'>
									<div className='tw-flex tw-items-center tw-gap-2'>
										<Indicator up={item.level.id > employee.level.id} className={color[view].lightColor} />
										<span>{item.level.value}</span>
										{view === 'algorithm' ? (
											<span className='tw-text-gray-400'>{item.area.value}</span>
										) : (
											<span className='tw-text-gray-400'>{item.subarea?.value}</span>
										)}
									</div>
								</div>
							))}
						</div>
						<div className='tw-font-bold tw-text-gray-500 tw-text-sm tw-mt-2'>
							{salary.carrerIndicatorsShow} {employee[`next_steps_${view}`].length} {salary.carrerIndicatorsResult}
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}
